import React from 'react'
import styled from 'styled-components'
import {getFontFamily, getFontLineHeight, getFontSize} from 'utils/commons'
import {ParagraphProps} from './ParagraphProps'

const StyledParagraph = styled.p<ParagraphProps>`
  ${({fontSize = 's', fontWeight = 'regular', theme, color = 'black'}) => ({
    fontSize: typeof fontSize === 'string' ? getFontSize(fontSize) : fontSize,
    lineHeight:
      typeof fontSize === 'string' ? getFontLineHeight(fontSize) : undefined,
    fontFamily: getFontFamily(fontWeight),
    color: color !== 'inherit' ? theme[color] : 'inherit',
  })}
  margin: 0;
`

export default function Paragraph({...props}: ParagraphProps) {
  return <StyledParagraph {...props} />
}
